const Message = () => ({
  required: {
    text: (field) => `${field} is required`,
    select: (field) => `Please select ${field}`,
  },
  min: {
    string: (min, field) => `${field} should contain minimum ${min} characters`,
    select: (min, field) => `Please select minimum ${min} ${field}`,
    numeric: (min, field) => `${field} should contain minimum ${min} digits`,
  },
  max: {
    string: (max, field) => `${field} should contain maximum ${max} characters`,
    select: (max, field) => `Please select maximum ${max} ${field}`,
    numeric: (max, field) => `${field} should contain maximum ${max} digits`,
  },
  len: {
    string: (len, field) => `${field} should contain ${len} characters`,
    select: (len, field) => `Please select ${len} ${field}`,
    numeric: (len, field) => `${field} should contain ${len} digits`,
  },
  email: () => `Invalid email format`,
  regex: {
    password: (field) =>
      `${field} must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters`,
    numeric: () => `Please enter digits only`,
    decimal: (number) =>
      `Please enter digits or decimal digits upto ${number} decimal only`,
    other: (field) => `Please enter valid ${field}`,
  },
  global: {
    networkIssue: "Network Issue!",
    internalServer: "Internal Server Error",
    notFound: "Not Found",
    unauthorize: "You are unauthorized to perform this action",
  },
  between: {
    numeric: (field, min, max) =>
      `The ${field} must be between ${min} and ${max}`,
  },
  url: `Invalid URL`,
  only_digit: "Only digit allow",
  space_not_allowed: "Space is not allow",
  only_string: "Only string allow",
  special_characters: "Full Name can only contain alphabets and spaces",
  successCreateUserMessage: (val) => `${val} Successfully created`,
  successMasterMessage: (val, status) =>
    `${val} has been successfully ${status}`,
  successRoleMessage: (val, status) => `${val} has been successfully ${status}`,
});

export default Message;
